import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer, ProgressBox, ProgressStat, Span } from '../styles';
import { polarColors } from '../constants';

const getColor = value => {
  if (value < 25) {
    return polarColors[4];
  }
  if (value < 50) {
    return polarColors[3];
  }
  if (value < 75) {
    return polarColors[1];
  }
  return polarColors[0];
};

const DysfunctionalBeliefsFourthPage = ({ user, background, number }) => {
  const indecisionGeneral = parseFloat(user['Indecisión General']);
  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h2>3.3. Indecisión como rasgo personal</h2>
          <p className='justified'>
            Una consideración clave en el proceso de toma de decisiones es{' '}
            <strong>
              identificar si la indecisión es un rasgo personal general o si
              está limitada a un área específica
            </strong>
            , como la elección de una carrera. Algunas personas pueden
            experimentar indecisión en múltiples áreas de su vida, lo que
            sugiere que puede ser un rasgo de personalidad más generalizado. En
            contraste, otras pueden tener dificultades específicas al elegir una
            carrera, pero no exhiben indecisión en otras áreas.
          </p>
          {/* <p className='justified'>
            Por ejemplo, una persona que se describe a sí misma como 'indecisa'
            puede tardar en tomar decisiones sobre qué ropa vestir, qué comida
            pedir en un restaurante o qué película ver. Esta indecisión
            generalizada podría llevar a la persona a tener problemas al tomar
            decisiones importantes, como la elección de una carrera, debido a la
            dificultad de comprometerse con una opción específica.
          </p> */}
          {/* <p className='justified'>
            Valores <strong>bajo 40</strong> en esta dimensión sugieren una
            dificultad para tomar decisiones en general que puede estar
            afectando tu capacidad para decidir sobre una carrera.
          </p> */}
          <div className='paragraph'>¿Cómo afrontar esta situación?</div>
          <ul className='text-list'>
            <li>- Desarrollo de habilidades de toma de decisiones.</li>
            <li>- Fomentar la confianza en sí mismo.</li>
            <li>- Práctica y experiencia.</li>
          </ul>
          <p className='justified'>
            Resultados en
            <Span strong color={polarColors[0]}>
              {' '}
              ROJO{' '}
            </Span>
            sugieren un alto nivel de indecisión general. <br />
            Resultados en{' '}
            <Span strong color={polarColors[4]}>
              VERDE
            </Span>{' '}
            sugieren un bajo nivel de indecisión general.
          </p>
          <div className='progress-info-group'>
            <div className='progress-info'>
              <div className='progress-details-single'>
                <div className='progress-name'>Indecisión General</div>
                <ProgressBox
                  progress={indecisionGeneral}
                  backColor={() => getColor(indecisionGeneral)}
                >
                  <div className='progress'></div>
                </ProgressBox>
                <ProgressStat>{indecisionGeneral}</ProgressStat>
              </div>
            </div>
          </div>
          <br />
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default DysfunctionalBeliefsFourthPage;
